<template>
  <div id="versionCheck">
    <div class="versionCheck__container">
      <div class="header">
        <img src="@/assets/logo/bi_x4.png" alt />
      </div>
      <div class="body">
        <div class="latest-version">
          <div class="title">최신 버전 :</div>
          <div class="contents">v {{ latestVersion }}</div>
        </div>
        <div class="user-current-version">
          <div class="title">현재 사용자 버전 :</div>
          <div class="contents">v {{ userCurrentVersion }}</div>
        </div>
        <!-- <div class="description">
          Ctrl + Shift + R
        </div> -->
        <!-- <div class="description2">OR</div> -->
        <div class="button" @click="strongRefresh" v-if="latestVersion !== userCurrentVersion">
          업데이트 실행
        </div>
        <div class="button" @click="goTeryWeb" v-else>
          현재 최선버전
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'versionCheck',
  data () {
    return {
      latestVersion: '',
      userCurrentVersion: process.env.version
    }
  },
  created () {},
  async mounted () {
    const vm = this
    const result = await vm.getHandyVersionCheck()
    vm.latestVersion = result.data.version
    if (vm.latestVersion === vm.userCurrentVersion) {
      console.log(vm.$route.query.seq)
      vm.goTeryWeb()
    }
  },
  methods: {
    strongRefresh () {
      window.location.reload()
    },
    goTeryWeb () {
      const vm = this
      if (!vm.$empty(vm.$route.query.seq)) {
        vm.$router.push({ path: '/storeMain', query: vm.$route.query })
      } else {
        vm.$router.push('/searchMain')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#versionCheck {
  width: 100%;
  height: 100vh;
  background: black;
  .versionCheck__container {
    position: absolute;
    left: 50%;
    top: 0%;
    max-width: 900px;
    text-align: center;
    transform: translate(-50%, 40%);
    .header {
      margin-bottom: 50px;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .body {
      .latest-version {
        font-size: 26px;
        letter-spacing: -0.125px;
        color: #fb7;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        .contents {
          padding-left: 10px;
        }
      }
      .user-current-version {
        font-size: 24px;
        letter-spacing: -0.125px;
        color: #fff;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        .contents {
          padding-left: 10px;
        }
      }
      .description {
        color: #fff;
        font-size: 40px;
      }
      .description2 {
        color: rgb(180, 180, 180);
        font-size: 25px;
        margin: 15px 0;
      }
      .button {
        width: 400px;
        height: 50px;
        margin: 0 auto;
        border: 1px solid rgb(36, 36, 36);
        line-height: 50px;
        text-align: center;
        background-color: rgb(36, 36, 36);
        border-radius: 10px;
        color: #fff;
        font-size: 25px;
        &:hover {
          cursor: pointer;
          transform: scale(1.05);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/versionCheck.vue